import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { RETRIEVE_EVENTO_LIST } from '../../data.const';
import {
  setListConfigAction,
  setLoaders,
  setPopupInfo,
  storeEventoListAction,
} from '../../data.action';
import { filler } from '../../../../../utils/utils';

const retrieveEventoListEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(RETRIEVE_EVENTO_LIST),
    map(({ payload }: any) => payload),
    // tap(p => console.log(`[epic ${RETRIEVE_EVENTO_LIST}]`, p)),
    withLatestFrom(state$),
    switchMap(([body, _state]) => {
      return concat(
        of(setLoaders({ eventoLoader: true })),
        of(setListConfigAction({ evento: body })),
        defer(() =>
          from(
            request({ path: `evento/list`, method: httpMethods.POST, body })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return { total: p?.total, result: [...p?.result, ...filler] };
            }),
            // tap(p => console.log(`[epic ${RETRIEVE_EVENTO_LIST}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(data => of(storeEventoListAction(data))),
            catchError(err => {
              console.error(`[epic ${RETRIEVE_EVENTO_LIST}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ eventoLoader: false }))
      );
    })
  );

export default retrieveEventoListEpic;
